
//Categories - Ct, Price Range - Pr, Duration - Dr, Activity Level - Al
Ct="", Pr="", Dr="", Al="";
	
var pID 	= "";
var pDate	= "";
var vyID	= "";
var trCode	= "";
var vyFlag	= "";
var exType	= "";
var gTrackingValue = "";

var data_xml;

//Get the available Categories and store in an Array
available_categories = [];

//Get the available Activity Levels and store in an Array
available_actLevels = [];
isResetClicked = "False";

function loadFiltersInCP(_pID, _pDate, _exType)
{
	pID 	= _pID;
	pDate	= _pDate;
	exType  = _exType;

	if(exType == "S")
		path = "./flashFilterList.page";
	else if(exType == "L")
		path = "./ldxFlashFilter.page";
		
	$.ajax({
		type: "GET",
		url: path+"?portid="+pID+"&portdate="+pDate,
		dataType: ($.browser.msie) ? "text" : "xml",
		success: function(xml)
		{
			processData(xml);
		},
		error: function(req,error)
		{
			if(error === 'error'){error = req.statusText;}
			//showError('An error has occured.');
			alert('An error has occured. '+req);
		}
	});
}
function loadFiltersOutsideCP(_pID, _pDate, _vyID, _trCode, _vyFlag, _exType)
{
	pID 	= _pID;
	pDate	= _pDate;
	vyID	= _vyID;
	trCode	= _trCode;
	vyFlag	= _vyFlag;
	exType 	= _exType;

	if(exType == "S")
		path = "/find/excursion/flashFilterList.do";
	else if(exType == "L")
		path = "/find/excursion/ldxFlashFilter.do";
		
	$.ajax({
		type: "GET",
		url: path+"?portid="+pID+"&portdate="+pDate+"&voyageid="+vyID+"&tourCode="+trCode+"&voyFlag="+vyFlag,
		dataType: ($.browser.msie) ? "text" : "xml",
		success: function(xml)
		{
			processData(xml);
		},
		error: function(req,error)
		{
			if(error === 'error'){error = req.statusText;}
			//showError('An error has occured.');
			alert('An error has occured. '+req);
		}
	});
}
function processData(xml) {
	if($.browser.msie){
		var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
		xmlDoc.loadXML(xml);
		xml = xmlDoc;
	}

	if($(xml).find('data').find('p').find('ex').length > 0)
	{
		$(xml).find('data').each(function()
		{
			if($(this).find('p').find('pid').text() == pID)
			{
				//Setup the UI (function defined in setup_ui.js)
				setup_ui($(this));
			}
		});
	}else
	{
		showErrorMsg("Excursion information is not yet available for this port.");
	}

}

function setup_ui(xml)
{	
	data_xml = xml;

	$(data_xml).find('p').find('ex').each(function()
	{
		var cat = $(this).find('cat').text();
		
		//if(available_categories.indexOf(cat)==-1 && cat!="")
		if(available_categories.toString().indexOf(cat)==-1 && cat!="")
			available_categories.push(cat);
	});
	
	//Display the category list
	set_categoriesList();
	
	$(data_xml).find('p').find('ex').each(function()
	{
		var alevel = $(this).find('s').text();
		
		if(alevel.indexOf(",") > -1)
		{
			var sAry = alevel.split(",");
			for(bl=0; bl<sAry.length; bl++)
			{
				if(available_actLevels.toString().indexOf(sAry[bl]) == -1)
					available_actLevels.push(sAry[bl]);
			}
		}else if(available_actLevels.toString().indexOf(alevel)==-1 && alevel!="")
		{
			available_actLevels.push(alevel);
		}
	});
	
	//Display the Activity Levels
	set_activityLevels();
	
	//Set the Reset button
	$( "#reset-filters" ).click(
		function()
		{
			isResetClicked = "True";
			resetAll();
		}
	);

	//Now all loaded & setup, display the Filters UI
	$('#filters').css("visibility", "visible");
	
	calXfound();
}

function set_categoriesList()
{
	//Display the list based on the available categories
	for(var a=1; a<=available_categories.length; a++)
	{
		var cat_name = getCtgryName(available_categories[a-1]);
		
		$('#categories').append("<li class='unselectable'><label for=ct"+a+"><input type='checkbox' name='ct"+a+"' value='"+available_categories[a-1]+"' id=ct"+a+" />  "+cat_name+"</label></li>");
		$("label[for='ct"+a+"']").css("visibility", "visible");
		
		//Setup the click event
		$( "#ct"+a ).click(
			function()
			{
				if ($(this).is(":checked"))
				{
					var ctgry = $(this).attr('value');
					//Add clicked activity in param Ct
					Ct += ctgry+",";
				}else
				{
					//Remove clicked activity from param Ct
					Ct = Ct.replace($(this).attr('value')+",",'');
				}
				
				calXfound();
			}
		);
		
		//Checked the checkbox and add the value in param
		$("#ct"+a).attr("checked", true);
		Ct += $("#ct"+a).attr('value')+",";
	}
}

//Return the Category Name as per the ID
function getCtgryName(id)
{
	switch (id)
	{
		case "ss":
		return "Sightseeing & City Tours";
		
		case "nw":
		return "Nature & Wildlife";
		
		case "aa":
		return "Activities & Adventures";
		
		case "si":
		return "Special Interests";
		
		case "ey":
		return "Exploring on Your Own";
	}
	return "";
}


function set_activityLevels()
{
	if(available_actLevels.toString().indexOf("h") == -1)
	{
		$("#alh").attr("disabled",true);
		$("#img_alh").attr("src","/static/images/global/excursions/handicap_lg_disable.jpg");
		$("label[for='alh']").attr('class','aLevel_disable');
		$("#alh").css('visibility','hidden');
		$("label[for='alh']").css('color','#666'); //Change the text color to grey
		$("label[for='alh']").css('cursor','default'); //Change the cursor to arrow
	}
		
	if(available_actLevels.toString().indexOf("1") == -1)
	{
		$("#al1").attr("disabled",true);
		$("#img_al1").attr("src","/static/images/global/excursions/walking_lg_disable.jpg");
		$("label[for='al1']").attr('class','aLevel_disable');
		$("#al1").css('visibility','hidden');
		$("label[for='al1']").css('color','#666'); //Change the text color to grey
		$("label[for='al1']").css('cursor','default'); //Change the cursor to arrow
	}else
	{
		$("#al1").attr("checked",true);
		//Add checked activity in param Al
		Al += "1,";
	}
		
	if(available_actLevels.toString().indexOf("2") == -1)
	{
		$("#al2").attr("disabled",true);
		$("#img_al2").attr("src","/static/images/global/excursions/stairs_lg_disable.jpg");
		$("label[for='al2']").attr('class','aLevel_disable');
		$("#al2").css('visibility','hidden');
		$("label[for='al2']").css('color','#666'); //Change the text color to grey
		$("label[for='al2']").css('cursor','default'); //Change the cursor to arrow
	}else
	{
		$("#al2").attr("checked",true);
		//Add checked activity in param Al
		Al += "2,";
	}
		
	if(available_actLevels.toString().indexOf("3") == -1)
	{
		$("#al3").attr("disabled",true);
		$("#img_al3").attr("src","/static/images/global/excursions/hiking_lg_disable.jpg");
		$("label[for='al3']").attr('class','aLevel_disable');
		$("#al3").css('visibility','hidden');
		$("label[for='al3']").css('color','#666'); //Change the text color to grey
		$("label[for='al3']").css('cursor','default'); //Change the cursor to arrow
	}else
	{
		$("#al3").attr("checked",true);
		//Add checked activity in param Al
		Al += "3,";
	}
	
	//If Accessible clicked, uncheck the Easy, Moderate & Strenuous
	$( "#alh" ).click(
		function()
		{
			if ($("#alh").is(":checked"))
			{
				//Uncheck the Easy, Moderate & Strenuous
				$( "#al1" ).removeAttr("checked");
				$( "#al2" ).removeAttr("checked");
				$( "#al3" ).removeAttr("checked");
				
				//Remove ids from the param Al
				Al = Al.replace("1,",'');
				Al = Al.replace("2,",'');
				Al = Al.replace("3,",'');
				
				//Add clicked activity in param Al
				Al += $(this).attr('id').substring(2)+",";
				
				disable_otherActLevels();
			}else
			{
				enable_otherActLevels();
			}
		}
	);
	
	//If Easy, Moderate & Strenuous clicked, uncheck the Accessible
	$( "#al1,#al2,#al3" ).click(
		function()
		{
			if ($(this).is(":checked"))
			{
				//Add clicked activity in param Al
				Al += $(this).attr('id').substring(2)+",";
			}else
			{
				//Remove clicked activity from param Al
				Al = Al.replace($(this).attr('id').substring(2)+",",'');
			}
			
			//If Accessible is checked, unchecked it
			if ($("#alh").is(":checked"))
			{
				//Uncheck Accessible
				$( "#alh" ).removeAttr("checked");
				
				//Remove Accessible id from param Al
				Al = Al.replace("h,",'');
			}
			
			var selCheckBoxCount = 0;
			
			if ($("#al1").is(":checked"))
			{
				selCheckBoxCount++;
			}
			if ($("#al2").is(":checked"))
			{
				selCheckBoxCount++;
			}
			if ($("#al3").is(":checked"))
			{
				selCheckBoxCount++;
			}
			
			
			calXfound();
	//alert("Al: "+Al);
		}
	);
}

function calXfound()
{
	var priceAry	= $( "#sliderPrice" ).slider( "option", "values" );
	var minPrice 	= parseFloat(priceAry[0]);
	var maxPrice 	= parseFloat(priceAry[1]);
	var durationAry	= $( "#sliderDuration" ).slider( "option", "values" );
	var minDuration = parseFloat(durationAry[0]);
	var maxDuration = parseFloat(durationAry[1]);
	var num = 0;
	var tmp_Ct		= Ct;
	var tmp_Al		= Al;
	
	if(maxPrice == 500)
		maxPrice = 10000;  //Change the value to make it 500+
		
	if(maxDuration == 5)
		maxDuration = 900;  //Change the value to make it 5+
		
	if(Ct.length == 0)
		Ct = available_categories.toString();
		
	if(Al.length == 0)
		Al = available_actLevels.toString();	

	$(data_xml).find('p').find('ex').each(function()
	{
		//$(data_xml).find('p').find('ex').filter("[ id = 1 ]");
		if(
		   $(this).find('pr').text() >= minPrice && 
		   $(this).find('pr').text() <= maxPrice && 
		   $(this).find('d').text() >= minDuration && 
		   $(this).find('d').text() <= maxDuration &&
		   checkForActivityLevels($(this).find('s').text()) == "True" &&
		   Ct.indexOf($(this).find('cat').text()) != -1)
				num++;
	});
	
	//Display the filtered result
	$('#result').html(num+' Excursions Found');
//alert(Ct+" | "+maxPrice+","+minPrice+" | "+maxDuration+","+minDuration+" | "+Al);

	if(exType == "S")
		showFilterList(Ct, maxPrice+","+minPrice, maxDuration+","+minDuration, Al, pID, pDate, vyID, trCode, vyFlag);
	else if(exType == "L")
		showLdxFilterList(Ct, maxPrice+","+minPrice, maxDuration+","+minDuration, Al, pID, pDate, vyID, trCode, vyFlag);
	
	Ct = tmp_Ct;
	Al = tmp_Al;
}

function checkForActivityLevels(alvl)
{
	if(alvl.indexOf(",") > -1)
	{
		var sAry = alvl.split(",");
		for(bl=0; bl<sAry.length; bl++)
		{
			if(Al.indexOf(sAry[bl]) != -1)
				return "True";
		}
	}else if(Al.indexOf(alvl) != -1)
	{
		return "True";;
	}else
	{
		return "False";
	}
}

$(function()
{
	// Slider
	$('#sliderPrice').slider({
		range: true,
		values: [0, 500],
		min: 0,
		max: 500,
		step: 25,
		animate: true
	});
	
	$('#sliderDuration').slider({
		range: true,
		values: [0, 5],
		min: 0,
		max: 5,
		step: .25,
		animate: true
	});
	
	//hover states on the static widgets
	$('#dialog_link, ul#icons li').hover(
		function() { $(this).addClass('ui-state-hover'); }, 
		function() { $(this).removeClass('ui-state-hover'); }
	);
	
	$( "#sliderPrice" ).slider({	
	   stop: function(event, ui) 
	   {
			if(isResetClicked == "False")
			{
				calXfound();
			}
	   }
	});
	$( "#sliderDuration" ).slider({
	   stop: function(event, ui) 
	   {
			if(isResetClicked == "False")
			{
				calXfound();
			}
	   }
	});
});

function disable_otherActLevels()
{
	for(var a=0; a<available_actLevels.length; a++)
	{
		if(available_actLevels[a] != 'h')
		{
			var id = available_actLevels[a];
			if(id == 1)
				$("#img_al"+id).attr("src","/static/images/global/excursions/walking_lg_disable.jpg");//Replce with the disable icon
			else if(id == 2)
				$("#img_al"+id).attr("src","/static/images/global/excursions/stairs_lg_disable.jpg");//Replce with the disable icon
			else if(id == 3)
				$("#img_al"+id).attr("src","/static/images/global/excursions/hiking_lg_disable.jpg");//Replce with the disable icon
			
			$("label[for='al"+id+"']").css('cursor','default');//Change the cursor to arrow
			$("#act-level div").css('color','#666');//Change the text color to grey
			$("#al"+id).css('visibility','hidden');//Hide the checkbox
			$("#al"+id).attr("disabled",true);//Disable the checkbox
		}
	}
	$("#al_message").css("visibility","visible");
	calXfound();
}

function enable_otherActLevels()
{
	var selCheckBoxCount = 0;
	
	for(var a=0; a<available_actLevels.length; a++)
	{
		if(available_actLevels[a] != 'h')
		{
				
			var id = available_actLevels[a];
			
			if(id == 1)
			{
				$("#img_al"+id).attr("src","/static/images/global/excursions/walking_lg.gif");//Replce with the enable icon
				selCheckBoxCount++;
			}else if(id == 2)
			{
				$("#img_al"+id).attr("src","/static/images/global/excursions/stairs_lg.gif");//Replce with the enable icon
				selCheckBoxCount++;
			}else if(id == 3)
			{
				$("#img_al"+id).attr("src","/static/images/global/excursions/hiking_lg.gif");//Replce with the enable icon
				selCheckBoxCount++;
			}
			
			$("label[for='al"+id+"']").css('cursor','pointer');//Change the cursor to hand
			$("#act-level div").css('color','#000');//Change the text color to black
			$("#al"+id).css('visibility','visible');//Visible the checkbox
			$("#al"+id).removeAttr("disabled");//Enable the checkbox
			$("#al"+id).attr('checked','true');//Check the checkbox
			Al += id+",";
		}
	}
	
	$("#al_message").css("visibility","hidden");
	
	//Remove accessible id from param
	Al = Al.replace("h,",'');
	
	if(isResetClicked == "False")
		calXfound();
}

function resetAll()
{
	//Reset the Category List
	resetCategoriesList();
	
	//Reset the Activity Levels
	resetActivityLevels();

	//Reset the Price Range Slider
	$( "#sliderPrice" ).slider( "option", "values", [0,500] );
	$( "#sliderDuration" ).slider( "option", "values", [0,5] );
	
	calXfound();
	
	isResetClicked = "False";
}

function resetCategoriesList()
{
	for(var a=1; a<=available_categories.length; a++)
	{
		if (!$("#ct"+a).is(":checked"))
		{
			//Checked the checkbox and add the value in param
			$("#ct"+a).attr("checked", true);
			Ct += $("#ct"+a).attr('value')+",";
		}
	}
}

function resetActivityLevels()
{
	if ($("#alh").is(":checked")) //If Accessible checked, unchecked it and enable other activity levels
	{
		enable_otherActLevels(); //Enable Activity Levels other than Accessible(Whelchair)
		$( "#alh" ).removeAttr("checked"); //Uncheck the Accessible(Whelchair)
	}else //If Accessible unchecked, check unchecked activity levels
	{		
		for(var a=0; a<available_actLevels.length; a++)
		{
			var id = available_actLevels[a];

			if(available_actLevels[a] != 'h' && !$("#al"+id).is(":checked"))
			{
				$("#al"+id).attr("checked","true");
				Al += available_actLevels[a]+",";
			}
		}
	}
}
		
//Return True if no price info available for any excursions
function isPriceRangeAvailable()
{
	var prNotFoundCount;
	
	$(data_xml).find('p').find('ex').each(function()
	{
		var pr = $(this).find('pr').text();
		
		if(pr == "" || pr == null)
			prNotFoundCount++;
	});
	
	//Send True if there is no price available for any excursion
	if(prNotFoundCount == $(data_xml).find('p').find('ex').length)
	{
		return false;
	}
	
	return true;
}

function getExType()
{
	if(exType == "S")
		return "shorex";
	else if(exType == "L")
		return "landex";
	else
		return null;
}

function showErrorMsg(msg)
{
	no_excursions();
	$("#error_msg").html("<h3>"+msg+"</h3>");
	$("#error_msg").css("visibility","visible");
}

/*function showFilterList(Ct, price, duration, Al, pID, pDate, vyID, trCode, vyFlag)
{
	//alert("Ct: "+Ct+", price: "+price+", duration: "+duration+", Al: "+Al+", pID: "+pID+", pDate: "+pDate+", vyID: "+vyID+", trCode: "+trCode+", vyFlag: "+vyFlag);
}*/